/**
 * Product Card Badges (compatibility wrapper)
 * For product cards in grids/carousels (not hero images). Shows max 2 badges.
 *
 * This is now a thin wrapper over the canonical <BadgeList variant="card" />.
 * It accepts either:
 *   - a canonical `badges: Badge[]` array (preferred, server-computed), OR
 *   - a legacy `product` object (falls back to client determineBadges()).
 *
 * New callers should pass `badges` directly. The `product` path exists only to
 * keep existing call-sites working during the migration to server-side badges.
 */

import { BadgeList } from './badge-list'
import { determineBadges, type Badge } from './config'
import { badgesFromTypes } from './select'

interface ProductCardBadgesProps {
  /** Canonical server-computed badges (preferred). */
  badges?: Badge[]
  /** Legacy product object — used only if `badges` is not provided. */
  product?: any
  maxBadges?: number
}

export function ProductCardBadges({
  badges,
  product,
  maxBadges = 2,
}: ProductCardBadgesProps) {
  const resolved = badges ?? (product ? badgesFromTypes(determineBadges(product)) : [])
  return <BadgeList badges={resolved} variant="card" max={maxBadges} />
}
